import axios from "axios";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const PointExchangeAPI = axios.create({
  baseURL: apiEndpoint.abcPointExchange,
  headers: {
    "content-type": "application/json",
  },
});
PointExchangeAPI.interceptors.request.use(refreshInterceptor);

export default PointExchangeAPI;
